export enum SoundStatus {
  Open = 1,
  Close = 2,
}
